import { Component, HostListener, OnInit, Pipe, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SharedModule } from '../shared-module/shared/shared.module'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { UserUtils } from "./UserUtils";
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ThemePalette } from '@angular/material/core';
import { reduce } from 'rxjs/operators';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, ErrorStateMatcher, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CountryServiceService } from '../country-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator } from '@angular/material/paginator';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { TraslateService } from '../traslate.service';
import { SelectionModel } from '@angular/cdk/collections';


export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}

export interface PeriodicElement {
  name: any;
  position: any;
  weight: any;
  symbol: any;
}
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})



export class UserComponent implements OnInit {
  hiddenContenu: any = 'true';
  URL: RequestInfo;
  json: any;
  repos: any;
  year: any;
  days: string = "dd"
  dtformt: string = "yyyy"
  pipe: DatePipe;
  alldata: any;
  displayedColumns: string[] = ['is_admin', 'last_name', 'first_name', 'username', 'email', 'created_at', 'expiration_date', 'is_active'];
  dataSource: any;
  value = '';
  lng: any = 'en_US'
  e: any;
  hide = true;
  hide2 = true;

  // we create an object that contains coordinates
  menuTopLeftPosition = { x: '0', y: '0' }
  @ViewChild('paginator', { static: true }) paginator: MatPaginator;

  // reference to the MatMenuTrigger in the DOM
  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger: MatMenuTrigger;
  itemsSelected: any;
  useraddform: any;
  country: any;
  countrySelect: any;
  state22: any;
  langue22: any;
  country22: any;
  iduser: any;
  submitStatus: boolean;
  listAdmin: any = [];
  email2: any = "issambenkaroum95@gmail.com"
  email: any;
  first_name: any;
  gsm_number: any;
  last_name: any;
  username: any;
  checkbox: string = '1';
  stateInfo: any[] = [];
  countryInfo: any[] = [];
  cityInfo: any[] = [];
  county: any;
  city: any;
  lang: any;
  expiration_date: any;
  is_active: any;
  allComplete2: boolean;
  allComplete3: boolean;
  spinnerActiveuser: boolean = false;
  spinnerActiveadduser: boolean = false;
  spinnerActiveablockuser: boolean = false;
  valuePassword: number;
  city1: any;
  DialogVisible: boolean;
  showedit: boolean;
  showadd: boolean;
  dialogRef: any;
  loading: boolean;
  filterValue: string = "";
  users: any;
  pageindex: number = 1;
  selection = new SelectionModel<any>(true, []);
  listItems: any[] = [];

  constructor(public traslateService: TraslateService, private formBuilder: FormBuilder, private dialog: MatDialog, private http: HttpClient, private countryService: CountryServiceService, private _snackBar: MatSnackBar, private spinnerTrame: NgxSpinnerService) {
  }
  ngOnInit(): void {

    this.getCountries();
    this.email2 = "issambenkaroum95@gmail.com"
    this.refrech()
    this.getUsers()
    this.onChangeCountry()
  }

  @HostListener("window:scroll", ["$event"])
  onWindowScroll(event) {
    let tracker = event.target;
    let limit = tracker.scrollHeight - tracker.clientHeight;
    if (event.target.scrollTop > limit) {
      console.log('Ello')
      this.loading = true;
      //  event.target.scrollTop=0
      this.getNextData();
      event.stopPropagation();
      return;
    }
  }



  getNextData() {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerTrame.show();
    this.pageindex = this.pageindex + 1;
    this.URL = environment.apiUrl + '/users?name=' + this.filterValue + '&page=' + this.pageindex;
    this.http.get(this.URL, requestOptions).subscribe((response: any) => {
      var list: any = response.data;
      this.listAdmin.push(...list);
      this.spinnerTrame.hide();
    })
  }

  pageChanged(event) {
    let pageIndex = event.pageIndex;


    let pageSize = event.pageSize;

    let previousIndex = event.previousPageIndex;

    let previousSize = pageSize * pageIndex;

    this.getNextData(

    );
  }


  getCountries() {
    this.countryService.allCountries().
      subscribe(
        data2 => {
          this.countryInfo = data2.Countries;
          //console.log('Data:', this.countryInfo);
        },
        err => console.log(err),
        () => console.log('complete')
      )
  }

  onChangeCountry() {



    this.stateInfo = this.countryInfo[this.countrySelect]?.States;
    this.cityInfo = this.stateInfo[this.countrySelect]?.Cities;
    //console.log('lkhkjlkjlkj,lkjkl'+JSON.stringify(this.countryInfo));
  }


  matcher = new MyErrorStateMatcher();

  hiddenContenuall(itemUser) {
    //console.log(itemUser.id); // 1, "string", false
    this.iduser = itemUser.id
    this.email = itemUser.email
    this.first_name = itemUser.first_name
    this.gsm_number = itemUser.gsm_number
    this.last_name = itemUser.last_name
    this.username = itemUser.username
    this.countrySelect = itemUser.country
    this.city1 = itemUser.city
    this.lang = itemUser.lang
    this.expiration_date = itemUser.expiration_date
    this.is_active = itemUser.is_active
    //console.log(itemUser)
    localStorage.setItem('object', itemUser.email);

    this.hiddenContenu = 'false'
    this.itemsSelected = itemUser

    //console.log(this.itemsSelected.id)
    this.useraddform = 'true'
    this.iduser = localStorage.getItem("object");
    this.country22 = 'ES'
    this.state22 = ''
    this.langue22 = 'fr_CA'
    localStorage.setItem('country22', this.country22);
    localStorage.setItem('state22', this.state22);
    localStorage.setItem('langue22', this.langue22);
    this.useraddform == 'true'
  }



  hiddenContenuall2() {
    this.hiddenContenu = 'false'
    this.itemsSelected = null
    this.useraddform = 'false'
    this.registerForm.reset();
    this.getValueInput()
  }
  hiddenContenuUser() {
    this.hiddenContenu = 'true';
    (<HTMLInputElement>document.getElementById('password')).value = "";
    (<HTMLInputElement>document.getElementById('passwordConfirm')).value = ""
    this.getUsers()
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onRightClick(event: MouseEvent, item) {
    // preventDefault avoids to show the visualization of the right-click menu of the browser
    event.preventDefault();

    // we record the mouse position in our object
    this.menuTopLeftPosition.x = event.clientX + 'px';
    this.menuTopLeftPosition.y = event.clientY + 'px';

    // we open the menu
    // we pass to the menu the information about our object
    this.matMenuTrigger.menuData = { item: item }

    // we open the menu
    this.matMenuTrigger.openMenu();


  }

  clearValue() {
    this.value = '';
    this.refrech()

  }
  hideDialog() {
    this.DialogVisible = false;
  }
  getUsers() {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.URL = environment.apiUrl + '/users'
    this.spinnerActiveuser = true
    this.spinnerTrame.show();

    this.http.get(this.URL, requestOptions).subscribe((response: any) => {
      this.listAdmin = response.data;
      this.spinnerTrame.hide();
      this.spinnerActiveuser = true
    })
  }
  async refrech() {
    this.getUsers()
  }
  async refrechdata() {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.URL = environment.apiUrl + '/users'
    this.spinnerActiveuser = true
    this.spinnerTrame.show();

    this.http.get(this.URL, requestOptions).subscribe((response) => {
      this.clearValue()
      //console.log(response)
      this.listAdmin = response

      this.spinnerTrame.hide();
      this.spinnerActiveuser = true
      this._snackBar.open('Les données des utilisateus sont actualisées', 'Fermer', {
        duration: 2000,

      });
    })
  }

  add(addUser) {
    this.showedit = false;
    this.showadd = true;
    //console.log('showedit   '+this.showedit)
    //console.log('showadd    '+this.showadd)
    this.modif_cancel();
    this.dialog.open(addUser, {
      // height:'900px',
      // width:'1233px',
      panelClass: 'my-Dialog'
    })
  }

  edit(user) {
    console.log(user)
    this.showedit = true;
    this.showadd = false;
    let dialogRef = this.dialog.open(EditUser, {

      data: {
        animal: 'panda'
      },
      disableClose: true,
      // width: '50%',
      autoFocus: false,
      panelClass: 'my-Dialog'
    });

    this.selection.clear()
    this.listItems = []
    this.listItems.push(user)
    this.traslateService.urluserQuote.next(this.listItems)
  }

  // edit(editUser) {
  //   this.showedit = true;
  //   this.showadd = false;
  //   this.modif_cancell();
  //   this.dialog.open(editUser,{
  //     panelClass:'my-Dialog'
  //   })
  // }

  modif_cancell() {
    this.registerFormUpdate.reset();
  }
  modif_cancel() {
    this.registerForm.reset();
  }
  async getOeuvresByTaskId() {
    var nameSearchElement: any = document.getElementById("searchInput")
    //console.log(nameSearchElement.value.length)


    if (nameSearchElement.value.length)
    // return this.dataService.getOeuvre().
    {
      this.filterValue = nameSearchElement.value;
      this.pageindex = 0;
      const headerDict = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Headers': 'Content-Type',
      }

      const requestOptions = {
        headers: new HttpHeaders(headerDict),
      };
      this.spinnerTrame.show();
      this.pageindex = 1;
      this.URL = environment.apiUrl + '/users?name=' + this.filterValue + '&page=' + this.pageindex;
      this.http.get(this.URL, requestOptions).subscribe((response: any) => {
        var list: any = response.data;
        this.listAdmin = list;
        this.spinnerTrame.hide();
      })

    }
    else {
      this.getUsers()
      //this.listAdmin = this.alldata;
    }

  }


  exportExcel(e, e2) {


    Swal.fire({
      title: 'Souhaitez-vous exporter la table type .' + e2 + ' ?',
      showCancelButton: true,
      confirmButtonText: 'Exporter Fichier !',
      cancelButtonText: 'Annuler',
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Export!',
          'Le fichier est exporté.',
        )
        //console.log(e);
        e.exportTable(e2, { fileName: 'STG_DRIVE_Users_' + new Date().toLocaleString(), sheet: 'STG DRIVE Users', Props: { 'Author': 'STG_DRIVE' } })
        /* var filename ='incoming message'

        const workSheet = XLSX.utils.json_to_sheet(this.dataSource.data, {header:["A","B","C","D","E","F",""], skipHeader:false});
        const workBook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, 'SheetName');
        XLSX.writeFile(workBook, filename+new Date()+'.xlsx'); */


        // For more information about handling dismissals please visit
        // https://sweetalert2.github.io/#handling-dismissals
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Annuler',
          'Fichier non exporté !!'
        )
      }
    })

  }
  exportTable() {

    Swal.fire({
      title: 'Souhaitez-vous exporter la table ?',
      showCancelButton: true,
      confirmButtonText: 'Exporter Fichier !',
      confirmButtonColor: '#262756',
      cancelButtonText: 'Annuler ',
      cancelButtonColor: "#e05a61",
    }).then((result) => {
      if (result.value) {


        UserUtils.exportToPdf("ExampleTable", "tbl");

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Annuler',
          'Fichier non exporté !!'
        )
      }
    })

  }




  vlue: any = 'US'


  task: Task = {
    name: 'Admin',
    completed: false,
    color: 'primary',
    subtasks: [
      { name: 'Droit_Admin', completed: false, color: 'primary' },
      { name: 'Droit_Admin', completed: false, color: 'accent' },
      { name: 'Droit_Admin', completed: false, color: 'warn' }
    ]
  };

  task2: Task = {
    name: 'Basic',
    completed: false,
    color: 'primary',
    subtasks: [
      { name: 'Droit_Basic', completed: false, color: 'primary' },
      { name: 'Droit_Basic', completed: false, color: 'accent' },
      { name: 'Droit_Basic', completed: false, color: 'warn' }
    ]
  };


  task3: Task = {
    name: 'Report',
    completed: false,
    color: 'primary',
    subtasks: [
      { name: 'Droit_Report', completed: false, color: 'primary' },
      { name: 'Droit_Report', completed: false, color: 'accent' },
      { name: 'Droit_Report', completed: false, color: 'warn' }
    ]
  };


  allComplete: boolean = false;

  updateAllComplete() {
    this.allComplete = this.task.subtasks != null && this.task.subtasks.every(t => t.completed);
    //console.log(this.allComplete +'dfsk')

  }

  someComplete(): boolean {
    if (this.task.subtasks == null) {
      return false;
    }
    return this.task.subtasks.filter(t => t.completed).length > 0 && !this.allComplete;
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.task.subtasks == null) {
      return;
    }
    this.task.subtasks.forEach(t => t.completed = completed);
  }

  updateAllComplete2() {
    this.allComplete2 = this.task2.subtasks != null && this.task2.subtasks.every(t => t.completed);
    //console.log(this.allComplete +'dfsk')

  }

  someComplete2(): boolean {
    if (this.task2.subtasks == null) {
      return false;
    }
    return this.task2.subtasks.filter(t => t.completed).length > 0 && !this.allComplete;
  }

  setAll2(completed: boolean) {
    this.allComplete2 = completed;
    if (this.task2.subtasks == null) {
      return;
    }
    this.task2.subtasks.forEach(t => t.completed = completed);
  }



  updateAllComplete3() {
    this.allComplete3 = this.task3.subtasks != null && this.task3.subtasks.every(t => t.completed);
    //console.log(this.allComplete +'dfsk')

  }

  someComplete3(): boolean {
    if (this.task3.subtasks == null) {
      return false;
    }
    return this.task3.subtasks.filter(t => t.completed).length > 0 && !this.allComplete;
  }

  setAll3(completed: boolean) {
    this.allComplete3 = completed;
    if (this.task3.subtasks == null) {
      return;
    }
    this.task3.subtasks.forEach(t => t.completed = completed);
  }



  onNoClickc(): void {

    let timerInterval
    Swal.fire({
      title: 'Modifier conducteur !',
      html: 'Enregistrement modification <b></b> en cours.',
      timer: 2000,
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading()
        timerInterval = setInterval(() => {
          const content = Swal.getContent()
          if (content) {
            const b = content.querySelector('b')
            if (b) {
              b.textContent = Swal.getTimerLeft()
            }
          }
        }, 100)
      },
      onClose: () => {
        clearInterval(timerInterval)
      }
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
        //console.log('I was closed by the timer')
        location.reload()
      }
    })


  }


  getvlue() {
    this.vlue = 'US'

    return 'US';
  }


  hiddenVlue() {

  }



  deleteUser(e) {


    Swal.fire({
      title: "Voulez-vous supprimer ce utilisateur?",
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: '#e05a61',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Annuler'

    }).then((result) => {
      this.spinnerActiveablockuser = true
      this.spinnerTrame.show();
      if (result.isConfirmed) {
        //console.log(e.id)


        this.http.delete(environment.apiUrl + '/users/[' + e.id + ']').subscribe((response) => {
          //console.log(response)
          //console.log(environment.apiUrl+'/users/'+JSON.stringify(e.id))

          this.getUsers()
          this.spinnerTrame.hide();
          this.spinnerActiveablockuser = false

        })


      }
    })
  }



  // tslint:disable-next-line:member-ordering
  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemark
    username: [, { validators: [Validators.required], updateOn: "change" }],
    first_name: [],
    last_name: [, { validators: [Validators.required], updateOn: "change" }],
    gsm_number: [],
    email: ['', { validators: [Validators.email], updateOn: "change" }],
    password: [, { validators: [], updateOn: "change" }],
    passwordConfirm: [, { validators: [], updateOn: "change" }],
    is_active: [],
    country: [],
    city: [],
    lang: [],
    expiration_date: []
  }, {
    validators: ConfirmedValidator('password', 'passwordConfirm')
  });


  // tslint:disable-next-line:member-ordering
  registerFormUpdate: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemark
    username: [, { validators: [Validators.required], updateOn: "change" }],
    first_name: [],
    last_name: [, { validators: [Validators.required], updateOn: "change" }],
    gsm_number: [],
    email: ['', { validators: [Validators.email], updateOn: "change" }],
    password: [, { validators: [], updateOn: "change" }],
    passwordConfirm: [, { validators: [], updateOn: "change" }],
    is_active: [],
    country: [],
    city: [],
    lang: [],
    expiration_date: []
  }, {
    validators: ConfirmedValidator('password', 'passwordConfirm')
  });

  submitForm() {
    //console.log('LKLK'+this.registerForm);

    Object.values(this.registerForm).forEach(val => {
      //console.log(val);
    });
    this.submitStatus = true;

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActiveadduser = true
    this.spinnerTrame.show();


    this.http.post(environment.apiUrl + '/users', this.registerForm.value, requestOptions).subscribe(response => {
      //console.log(response)
      var resp: any = response

      if (resp.status == 200) {
        //console.log(200)

        Swal.fire({
          position: 'center',
          title: 'Utilisateur enregistré avec succès!',
          showConfirmButton: false,
          timer: 1000
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {

            this.getUsers()
            this.hiddenContenuUser();
            (<HTMLInputElement>document.getElementById('password')).value = "";
            (<HTMLInputElement>document.getElementById('passwordConfirm')).value = ""
          }
        })
        this.spinnerTrame.hide();
        this.spinnerActiveadduser = false


      } else if (resp.status == 500) {
        this.spinnerTrame.hide();
        this.spinnerActiveadduser = false

        //console.log(500)
        Swal.fire({
          html: resp.message.join('<br>'),
        })
      }
    })



  }

  getValueInput() {
    if ((<HTMLInputElement>document.getElementById('password'))?.value?.length == 0) {
      this.valuePassword = 0
      //console.log(this.valuePassword ,'jkhjkhjk')
    } else {
      this.valuePassword = 1
    }
  }
  submitFormUpdate(e) {

    //console.log('LKLK'+JSON.stringify(this.registerFormUpdate.value));

    Object.values(this.registerFormUpdate).forEach(val => {
      //console.log(val);
    });
    this.submitStatus = true;

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActiveadduser = true
    this.spinnerTrame.show();


    this.http.put(environment.apiUrl + '/users/' + e, this.registerFormUpdate.value, requestOptions).subscribe(response => {
      //console.log(response)
      var resp: any = response

      if (resp.status == 200) {
        //console.log(200)

        Swal.fire({
          position: 'center',
          title: 'Modification enregistré avec succès!',
          allowOutsideClick: false,


          confirmButtonText: `OK`,

        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {

            this.getUsers()
            this.hiddenContenuUser();
            (<HTMLInputElement>document.getElementById('password')).value = "";
            (<HTMLInputElement>document.getElementById('passwordConfirm')).value = ""
          }
        })


        this.spinnerTrame.hide();
        this.spinnerActiveadduser = false
      } else if (resp.status == 500) {
        //console.log(500)
        this.spinnerTrame.hide();
        this.spinnerActiveadduser = false
        Swal.fire({
          html: resp.message.join('<br>'),

        })
      }
    })





  }

  blockUser(e) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActiveablockuser = true
    this.spinnerTrame.show();
    this.http.post(environment.apiUrl + '/users/' + JSON.stringify(e.id) + '/block', requestOptions).subscribe((response) => {
      //console.log(response)
      //location.reload()
      this.getUsers()
    })

    this.spinnerTrame.hide();
    this.spinnerActiveablockuser = false
  }

  unblockUser(e) {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActiveablockuser = true
    this.spinnerTrame.show();
    this.http.post(environment.apiUrl + '/users/' + JSON.stringify(e.id) + '/unblock', requestOptions).subscribe((response) => {
      //console.log(response)
      //location.reload()
      this.getUsers()
      this.spinnerTrame.hide();
      this.spinnerActiveablockuser = false
    })

  }
}

export function ConfirmedValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmedValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  }
}

@Component({
  selector: 'editUser',
  templateUrl: 'EditUser.html',
  styleUrls: ['./user.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true }
  }]
})

export class EditUser implements OnInit {
  url: any;
  hide2 = true;
  URL: RequestInfo;
  hiddenContenu: any = 'true';
  spinnerActiveuser: boolean;
  submitStatus: boolean;
  listAdmin: any = [];
  spinnerActiveadduser: boolean;
  email: any;
  first_name: any;
  gsm_number: any;
  last_name: any;
  username: any;
  checkbox: string = '1';
  stateInfo: any[] = [];
  countryInfo: any[] = [];
  cityInfo: any[] = [];
  country: any;
  city: any;
  lang: any;
  expiration_date: any;
  matcher = new MyErrorStateMatcher();
  hide = true;
  itemsSelected: any;
  countrySelect: any;
  id: any;
  value: string;

  constructor(private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private http: HttpClient,
    private countryService: CountryServiceService,
    public traslateService: TraslateService,
    private _snackBar: MatSnackBar,
    private spinnerTrame: NgxSpinnerService) {
  }

  registerFormUpdate: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemark
    username: [, { validators: [Validators.required], updateOn: "change" }],
    first_name: [],
    last_name: [, { validators: [Validators.required], updateOn: "change" }],
    gsm_number: [],
    email: ['', { validators: [Validators.email], updateOn: "change" }],
    password: [, { validators: [], updateOn: "change" }],
    passwordConfirm: [, { validators: [], updateOn: "change" }],
    is_active: [],
    country: [],
    city: [],
    lang: [],
    expiration_date: []
  }, {
    validators: ConfirmedValidator('password', 'passwordConfirm')
  });

  ngOnInit(): void {
    this.getCountries();
    this.traslateService.currentUserQuote.subscribe(data => {
      this.url = data
      console.log(this.url)
      this.countryService.allCountries().subscribe(
        (data2): any => {
          this.stateInfo = data2.Countries[this.url[0].country].States;
        },
      )
    })

    for (let entry of this.url) {
      this.id = entry.id
      this.username = entry.username
      this.first_name = entry.first_name
      this.last_name = entry.last_name
      this.gsm_number = entry.gsm_number
      this.email = entry.email
      this.lang = entry.lang
      this.city = entry.city
      this.country = entry.country
      this.expiration_date = entry.expiration_date
    }

    this.getUsers()
  }

  hiddenContenuUser() {
    this.hiddenContenu = 'true';
    (<HTMLInputElement>document.getElementById('password')).value = "";
    (<HTMLInputElement>document.getElementById('passwordConfirm')).value = ""
    this.getUsers()
  }

  getUsers() {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.URL = environment.apiUrl + '/users'
    this.spinnerActiveuser = true
    this.spinnerTrame.show();
    this.http.get(this.URL, requestOptions).subscribe((response: any) => {
      this.listAdmin = response.data;
      this.spinnerTrame.hide();
      this.spinnerActiveuser = true
    })
  }

  submitFormUpdate(e) {
    Object.values(this.registerFormUpdate).forEach(val => {
    });
    this.submitStatus = true;
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActiveadduser = true
    this.spinnerTrame.show();
    this.http.put(environment.apiUrl + '/users/' + e, this.registerFormUpdate.value, requestOptions).subscribe(response => {
      var resp: any = response
      if (resp.status == 200) {
        Swal.fire({
          position: 'center',
          title: resp["message"],
          allowOutsideClick: false,
          confirmButtonText: `OK`,
        }).then((result) => {
          if (result.isConfirmed) {
            this.getUsers()
            // this.hiddenContenuUser();
            // (<HTMLInputElement>document.getElementById('password')).value = "";
            // (<HTMLInputElement>document.getElementById('passwordConfirm')).value = ""
            // location.reload()
          }
        })
        this.spinnerTrame.hide();
        this.spinnerActiveadduser = false
      } else if (resp.status == 500) {
        this.spinnerTrame.hide();
        this.spinnerActiveadduser = false
        Swal.fire({
          html: resp.message.join('<br>'),

        })
      }
    })
  }

  getCountries() {
    this.countryService.allCountries().
      subscribe(
        data2 => {
          this.countryInfo = data2.Countries;
        },
        err => console.log(err),
        () => console.log('complete')
      )
  }

  onChangeCountry(countryValue) {
    this.stateInfo = this.countryInfo[countryValue.value].States;
    this.cityInfo = this.stateInfo[0].Cities;
  }


}
